import type { SeedListData } from '@openx/types/segments';
import type { Dispatch } from 'react';
import { dispatchAddItem } from './dispatchers';
import type { Action } from './types';

export const addItem = (item: SeedListData, prevValue: SeedListData[], dispatch: Dispatch<Action>) => {
  const updatedValue = [...prevValue, item];

  dispatchAddItem(dispatch, item);
  return updatedValue;
};
